<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Although born in Murray County Utah, when she was two her family moved to Baltimore Maryland where she spent her childhood until she was 12 years old. Her family then moved to Tucson Arizona. After returning briefly to Maryland they returned to Tucson when she graduated high school, where she currently lives with her husband William. In 2004, she obtained a BA in English from the University of Arizona and currently works as a substitute teacher.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?335cec89